export default __webpack_public_path__ + "static/media/cprx_tile-mobile.png.webp";